import { useState, } from 'react';

import { Table, } from 'react-bootstrap';
import { Container, TableContainer, TablePagination, Paper, } from '@material-ui/core';

import CorpoChamado from '../Chamados';

import styles from './styles.module.scss';


function TicketsTable({ tickets, }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);


  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }


  return (
    <TableContainer
      maxWidth="xl"
      component={Paper}
      elevation={2}
      disableGutters
      style={{
        minHeight: '50.6rem',
        margin: '0.5rem 0',
      }}
    >
      <Container
        className={styles.StyleTable}
        maxWidth="xl"
      >
        <Table
          striped
          hover
          responsive
        >
          <thead>
            <tr>
              <th>Empresa</th>
              <th>Assunto</th>
              <th>Status</th>
              <th>Responsavel</th>
              <th>Data</th>
            </tr>
          </thead>

          {
            tickets
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <CorpoChamado key={row.id} data={row} />
              ))
          }
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
          component="div"
          count={tickets.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Container>
    </TableContainer>
  );
}

export default TicketsTable;
